export default "__VITE_ASSET__D$g16AdU__"